export function getNavigator() {
	if (typeof window !== 'undefined') {
		return navigator;
	}
}
